import CustomButton from "../../../components/common/CustomButton/CustomButton";
import CustomDataGrid from "../../../components/common/CustomDataGrid/CustomDataGrid";

import CustomSwitch from "../../../components/common/CustomSwitch";
import { Trash2, Eye, EyeOff } from "lucide-react";

import { useState } from "react";
import CustomTextInputBasic from "../../../components/common/CustomTextInput/CustomTextInputBasic";

const WhatsAppTab = ({ providers, onStatusChange, onEdit, onDelete, onAdd }) => {
    const [visibleApiKeyId, setVisibleApiKeyId] = useState(null);
  
    // Find the currently active provider
    const activeProvider = providers.find((p) => p.isActive);
  
    const handleStatusChange = (id, newValue) => {
      onStatusChange(id, newValue);
    };
  
    return (
      <div className="flex flex-col gap-3 ">
        {/* Add Provider Button */}
        <div className="flex justify-end">
          <CustomButton
            label="Add New Provider"
            onClick={() => onAdd('whatsapp')}
          />
        </div>
  
        {/* Providers DataGrid */}
        <CustomDataGrid
          columns={[
            {
              field: "serial",
              headerName: "#",
              width: "80px",
              renderCell: (row, index) => (
                <span className="text-gray-600">{row.id}</span>
              )
            },
            {
              field: "providerName",
              headerName: "Provider Name",
              width: "200px",
              renderCell: (row) => (
                <span className="text-gray-700">{row.providerName}</span>
              )
            },
            {
              field: "apiKey",
              headerName: "API KEY",
              width: "200px",
              renderCell: (row) => (
                <div className="w-full">
                  <CustomTextInputBasic
                    value={visibleApiKeyId === row.id ? row.apiKey : row.apiKey.replace(/./g, '•')}
                    disabled
                    endIcon={
                      <button 
                        className="text-blue-600 hover:text-blue-700 transition-colors"
                        onClick={() => setVisibleApiKeyId(visibleApiKeyId === row.id ? null : row.id)}
                      >
                        {visibleApiKeyId === row.id ? <EyeOff size={16} /> : <Eye size={16} />}
                      </button>
                    }
                  />
                </div>
              )
            },
            {
              field: "senderName",
              headerName: "Sender Name",
              width: "200px",
              renderCell: (row) => (
                <span className="text-gray-700">{row.senderName}</span>
              )
            },
            {
              field: "senderEmail",
              headerName: "Sender Email",
              width: "200px",
              renderCell: (row) => (
                <span className="text-gray-700">{row.senderEmail}</span>
              )
            },
            {
              field: "actions",
              headerName: "Action",
              width: "150px",
              renderCell: (row) => (
                <div className="flex items-center gap-4">
                  <CustomSwitch 
                    value={row.isActive}
                    name={`provider-status-${row.id}`}
                    onChange={(newValue) => handleStatusChange(row.id, newValue)}
                  />
                  <div className="flex items-center gap-2">
                    <button 
                      className="p-1.5 hover:bg-gray-100 rounded-md transition-colors"
                      onClick={() => onEdit(row)}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                      </svg>
                    </button>
                    <button 
                      className="p-1.5 hover:bg-red-50 rounded-md transition-colors"
                      onClick={() => onDelete(row)}
                    >
                      <Trash2 size={16} className="text-red-600" />
                    </button>
                  </div>
                </div>
              )
            }
          ]}
          rows={providers}
          keyId="id"
        />
      </div>
    );
  };
  export default WhatsAppTab;